import Quill from 'quill';

const Link = Quill.import('formats/link') as any;

export class QuillLinkFormat extends Link {
  static sanitize(url: string): string {
    url = url?.trim() ?? '';
    const lower = url.toLowerCase();
    if (!lower.startsWith('http://') && !lower.startsWith('https://') && !lower.startsWith('mailto:')) {
      url = 'https://' + url;
    }
    return super.sanitize(url);
  }
}
